/**
 * Date utility functions for consistent local timezone handling.
 */

/**
 * Get today's date in local timezone as YYYY-MM-DD string.
 * @returns {string} Date string in YYYY-MM-DD format
 */
export function getLocalToday() {
  return formatLocalDate(new Date());
}

/**
 * Format a Date object as YYYY-MM-DD string in local timezone.
 * @param {Date} date - Date object to format
 * @returns {string} Date string in YYYY-MM-DD format
 */
export function formatLocalDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Add days to a date and return as YYYY-MM-DD string.
 * @param {Date|string} date - Date object or YYYY-MM-DD string
 * @param {number} days - Number of days to add (negative to subtract)
 * @returns {string} Date string in YYYY-MM-DD format
 */
export function addDays(date, days) {
  const d = typeof date === 'string' ? new Date(date + 'T00:00:00') : new Date(date);
  d.setDate(d.getDate() + days);
  return formatLocalDate(d);
}

/**
 * Add months to a date and return as YYYY-MM-DD string.
 * @param {Date|string} date - Date object or YYYY-MM-DD string
 * @param {number} months - Number of months to add (negative to subtract)
 * @returns {string} Date string in YYYY-MM-DD format
 */
export function addMonths(date, months) {
  const d = typeof date === 'string' ? new Date(date + 'T00:00:00') : new Date(date);
  d.setMonth(d.getMonth() + months);
  return formatLocalDate(d);
}
